import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { getUserCookies } from "../utils/Cookies";

const useAuth = () => {
  const [token, setToken] = useState(null);
  const [highestRole, setHighestRole] = useState(null);
  const [marketRole, setMarketRole] = useState(null);

  const initializeAuth = () => {
    const userCookies = getUserCookies();
    const userToken = userCookies?.token || null;
    let role = null;
    let market_role = null;

    if (userToken) {
      try {
        const decoded = jwtDecode(userToken);
        role = decoded.highest_role || null;
        market_role = decoded.market_role || null;
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }

    setToken(userToken);
    setHighestRole(role);
    setMarketRole(market_role);
  };

  useEffect(() => {
    initializeAuth();

    let previousToken = getUserCookies()?.token;

    const checkForTokenChange = () => {
      const newToken = getUserCookies()?.token;
      if (newToken !== previousToken) {
        previousToken = newToken;
        initializeAuth();
      }
      setTimeout(checkForTokenChange, 1000); // Re-check after 1s
    };

    checkForTokenChange();

    return () => clearTimeout(checkForTokenChange);
  }, []);

  return { token, highestRole, marketRole };
};

export default useAuth;
